<script>
import { HomeIcon, MailIcon,KeyIcon, HashIcon } from "vue-feather-icons";

import {post} from "@/assets/js/utils";
import config from "@/config.json";

/**
 * Auth-re-password component
 */
export default {
  data() {
    return {
      email: "",
      status: 0,
      from: 'Web.Mirror',
      password: "",
      captcha_code: "",
      code: "",
      accepted: false,
      showResend: true,
      loading: false,
      showTip: false,
      isSuccess: false,
      message: "",
      captcha: {
        img: "",
        key: "",
        sensitive: false
      }
    };
  },
  mounted() {
    this.getCaptcha();
  },
  methods: {
    async forgot() {
      const {email, captcha_code} = this;
      if (email.trim() === "" || captcha_code.trim() === "") {
        return;
      }
      this.loading = true;
      try {
        const data = await post(`${config.api.forgotpass}`, {email, key: this.captcha.key, captcha: captcha_code, app: "Design Mirror"});
        this.loading = false;
        if (data.errno === 0) {
          this.status = 1;
        } else {
          this.showError(data.info);
        }
      } catch (e) {
        this.showError(e.toString());
      }
    },
    async reset() {
      if (this.code.trim() === "" || this.email.trim() === "" || this.password.trim() === "") {
        return;
      }
      this.loading = true;
      try {
        const {email, code, password} = this;
        const params = {email, password, code};
        const ak = localStorage.getItem("access_key");
        if (ak) {
          params['access_key'] = ak;
        }
        const data = await post(`${config.api.resetpass}`, params);
        if (data.errno === 0) {
          localStorage.setItem("access_key", data['access_key']);
          localStorage.setItem("access_token", data['access_token']);
          this.showTip = true;
          this.isSuccess = true;
          this.message = this.$t('reset_pass.successTip');
          setTimeout(() => {
            this.$router.push('/profile');
          }, 1000);
        } else {
          this.showError(data.info);
        }
      } catch (e) {
        this.showError(e.toString());
      }
    },
    async resendMail() {
      try {
        const {email} = this;
        const data = await post(`${config.api.resend}`, {email, type: 2, app: "Design Mirror"});
        if (data.errno === 0) {
          this.showResend = false;
          setTimeout(() => { this.showResend = true; }, 60*1000);
        } else {
          this.showError(data.info);
        }
      } catch (e) {
        this.showError(e.toString());
      }
    },
    async getCaptcha() {
      try {
        const data = await post(`${config.api.captcha}`, {});
        if (data.errno === 0) {
          this.captcha = data;
        }
      } catch (e) {
      }
    },
    showError(msg) {
      this.loading = false;
      this.showTip = true;
      this.isSuccess = false;
      this.message = msg;
      this.captcha_code = "";
      this.getCaptcha();
    }
  },
  components: {
    MailIcon,
    HomeIcon,
    KeyIcon,
    HashIcon
  },
};
</script>

<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <router-link to="/" class="btn btn-icon btn-soft-primary">
        <home-icon class="icons"></home-icon>
      </router-link>
    </div>

    <!-- Hero Start -->
    <section class="bg-home d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-6">
            <div class="mr-lg-5">
              <img
                src="images/user/recovery.svg"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </div>
          </div>
          <div class="col-lg-5 col-md-6">
            <div class="card shadow rounded border-0">
              <div class="card-body">
                <h4 class="card-title text-center">{{$t('reset_pass.title')}}</h4>

                <form class="login-form mt-4" @submit.prevent="forgot" v-if="status === 0">
                  <div class="row">
                    <div class="col-lg-12">
                      <p class="text-muted"> {{$t('reset_pass.description')}} </p>
                      <div class="form-group">
                        <label >{{$t('reset_pass.email')}} <span class="text-danger">*</span></label >
                        <div class="position-relative">
                          <mail-icon class="fea icon-sm icons"></mail-icon>
                          <input
                            type="email"
                            v-model="email"
                            class="form-control pl-5"
                            :placeholder="$t('reset_pass.emailTip')"
                            name="email"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label>{{$t('signup.captcha')}} <span class="text-danger">*</span></label>
                        <div class="row">
                          <div class="position-relative col-md-6">
                            <hash-icon class="fea icon-sm icons ml-3"></hash-icon>
                            <input @focus="showTip=false" v-model="captcha_code" type="text" class="form-control pl-5" :placeholder="$t('signup.captcha_tip')" required="">
                          </div>
                          <div class="col-md-6" v-if="captcha.img !== ''">
                            <img :src="captcha.img" alt="" height="40"/>
                            <a href="#" @click.prevent="getCaptcha" class="ml-2 btn btn-icon btn-pills btn-outline-dark"><i class="uil uil-sync"></i></a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div v-if="showTip" class="alert " :class="{'alert-danger': !isSuccess, 'alert-success': isSuccess}" role="alert">
                        <i v-if="isSuccess" class="uil uil-check"></i>
                        <i v-if="!isSuccess" class="uil uil-times"></i>
                        {{message}}
                      </div>
                      <button :disabled="loading" class="btn btn-primary btn-block">{{$t('reset_pass.send')}}</button>
                    </div>
                    <div class="mx-auto">
                      <p class="mb-0 mt-3">
                        <small class="text-dark mr-2" >{{$t('reset_pass.remember')}}</small >
                        <router-link to="/auth-login" class="text-primary font-weight-bold" >{{$t('reset_pass.login')}}</router-link >
                      </p>
                    </div>
                  </div>
                </form>


                <form class="login-form mt-4" @submit.prevent="reset" v-if="status === 1">
                  <div class="row">
                    <div class="col-lg-12">
                      <p class="text-muted" v-html="$t('reset_pass.emailSend', {email: this.email})"> </p>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group ">
                        <label>{{$t('reset_pass.newPass')}} <span class="text-danger">*</span></label>
                        <div class="position-relative">
                          <key-icon class="fea icon-sm icons"></key-icon>
                          <input @focus="showTip=false" v-model="password" type="password" class="form-control pl-5" :placeholder="$t('signup.passwordTip')" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label >{{$t('signup.captcha')}} <span class="text-danger">*</span></label >
                        <div class="row">
                          <div class="col-md-6">
                            <hash-icon class="ml-3 fea icon-sm icons"></hash-icon>
                            <input
                                @focus="showTip=false"
                                v-model="code"
                                type="text"
                                class="form-control pl-5"
                                :placeholder="$t('signup.token.token_tip')"
                                name="code"
                                required=""
                            />
                          </div>
                          <div class="col-md-6">
                            <a v-if="showResend" href="#" @click.prevent="resendMail" class="badge badge-primary"><i class="uil uil-sync"></i> {{$t('signup.token.resend_token')}}</a>
                            <span style="font-size: 14px" v-if="!showResend" v-html="$t('signup.token.resend_tip')"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div v-if="showTip" class="alert " :class="{'alert-danger': !isSuccess, 'alert-success': isSuccess}" role="alert">
                        <i v-if="isSuccess" class="uil uil-check"></i>
                        <i v-if="!isSuccess" class="uil uil-times"></i>
                        {{message}}
                      </div>
                      <button class="btn btn-primary btn-block">{{$t('reset_pass.submit')}}</button>
                    </div>
                  </div>
                </form>


              </div>

            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->
  </div>
</template>
